import { DateService } from './../../services/date.service';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { APIs } from 'src/app/config/api.constant';
import { forkJoin } from 'rxjs';
import { AppConstant } from 'src/app/config/app.constant';
import { AppStateProvider } from 'src/app/providers/app-state.provider';

@Component({
  standalone: false,
  selector: 'app-booking-confirmation',
  templateUrl: './booking-confirmation.component.html',
  styleUrls: ['./booking-confirmation.component.scss'],
})
export class BookingConfirmationComponent implements OnInit {
  closeResult: string;
  meetingNav;
  filteredItems: any;
  cancelBooking: boolean = false;
  searchtext: string = '';
  val: string;
  showExternalDetails: boolean = false;
  totalSelected: number = 0;
  entity = new Entity();
  [x: string]: any;
  meetingInfo = new MeetingInfo();
  unfilteredItems: any[] = [];
  items: any[] = [];
  MeetingId: number;
  fromTime: string;
  toTime: string;
  FirstName: string;
  LastName: string;
  date: string;
  duration: number;
  meetingRoomName: string;
  meetingRoomImage: string;
  noOfPax: number;
  meetingDate: Date;
  meetingStatus: string;
  meetingCancelledDate: Date;
  meetingAttendees: any[] = [];
  a: string = '';
  inviteeModalContent;
  selectedHost;
  ftname: boolean;
  firstName: '';
  lname: boolean;
  lastName: '';
  email: boolean;
  emailid: '';
  mobile: boolean;
  fieldErrors: any = [];
  maxReached: boolean = false;
  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private commonService: CommonService,
    private appStateSrv: AppStateProvider,
    private dateSrv: DateService
  ) { }

  ngOnInit(): void {
    this.meetingNav = [
      {
        index: '2',
        name: 'Meeting',
        link: '/meeting/meetingroom-list/bookmeetingroomconfirm',
      },
    ];

    const route = {
      index: '2',
      name: 'Meeting',
      link: '/meeting/meetingroom-list/bookmeetingroomconfirm',
    };
    this.appStateSrv.setSideNavState(route);

    this.getApiauthorizationToken();
  }

  public getApiauthorizationToken() {
    // this.commonService.getApiauthorizationToken().subscribe((res) => {
    if (localStorage.getItem(AppConstant.localStorage.token) != null) {
      this.getPageData2();
    }
    // });
  }

  public getPageData2() {
    // this.checkedItems = [];
    this.items = [];
    this.MeetingId = JSON.parse(
      localStorage.getItem('MeetingData')
    ).MeetingRoomBookingId;

    forkJoin([
      this.apiService.get(APIs.getmeetingInviteesWithExternals, {
        tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
        meetingRoomBookingId: this.MeetingId,
      }),
      this.apiService.get(APIs.getMeetingDetail, { Id: this.MeetingId }),
      this.apiService.get(APIs.getMeetingInviteesList, {
        MeetingId: this.MeetingId,
      }),
    ]).subscribe(
      (results) => {
        let duration = results[1].data.duration.toString();
        let meetingRoomImageList =
          results[1].data.meetingRoom.m0300MeetingRoomImages;
        let minutesInDuration = duration.split('.')[1];
        this.unfilteredItems = results[0].list;
        this.fromTime = results[1].data.fromTime;
        this.toTime = results[1].data.toTime;
        this.duration =
          minutesInDuration?.length == 1 ? duration + '0' : duration;
        this.meetingRoomName = results[1].data.meetingRoom.name;
        this.noOfPax = results[1].data.meetingRoom.noOfPax;

        this.meetingAttendees = this.getMeetingAttendees(results[2].list);
        this.meetingStatus = results[1].data.status;
        this.meetingDate = results[1].data.date.split('T')[0];
        if (this.meetingStatus == 'Cancelled')
          this.meetingCancelledDate =
            results[1].data.modifiedDate.split('T')[0];
        this.FilterEmployeeList();
        this.meetingRoomImage =
          meetingRoomImageList.find(
            (x) => x.meetingRoomId == results[1].data.meetingRoomId
          ) != null
            ? meetingRoomImageList.find(
              (z) => z.meetingRoomId == results[1].data.meetingRoomId
            )?.imagePath
            : null;
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  public FilterEmployeeList() {
    this.unfilteredItems.forEach((data) => {
      var itemToChange = this.meetingAttendees.find((a) => a.id == data.id);
      if (itemToChange != null) data.selected = true;
      this.items.push(data);
    });
    this.totalSelected = this.items.filter((x) => x.selected)?.length;
  }
  public getMeetingAttendees(list) {
    let attendees = list?.filter((x) => x.isSelected);
    return attendees.length > 1
      ? attendees.sort((a, b) => (a.isActive < b.isActive ? 1 : -1))
      : attendees;
  }
  public openXl(content) {
    this.searchtext = null;
    this.showExternalDetails = false;
    this.inviteeModalContent = content;
    this.modalService.open(content, { size: 'xl' });
  }

  public CancelBooking() {
    this.cancelBooking = true;
    this.apiService
      .post(APIs.cancelMeeting + `/${this.MeetingId}`, '', '')
      .subscribe(
        (result) => {
          if (result.isValid) {
            this.getPageData2();
            this.appStateSrv.showToast('Meeting Cancelled Successfully.');
          } else {
            this.appStateSrv.showToast(result.errorMsg);
          }
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  public onClickAddMember() {
    this.entity = new Entity();
    this.fieldErrors = [];
    this.showExternalDetails = true;
  }

  public onClickBack() {
    this.showExternalDetails = false;
  }

  public OnCheckBoxChange(item) {
    // this.totalSelected = 0;
    // let noOfInvitiesSelected = this.items.filter(
    //   (i) => i.selected == true
    // ).length;
    // this.totalSelected = noOfInvitiesSelected;
    // if (noOfInvitiesSelected > this.noOfPax - 1) {
    //   this.items.find((x) => x.emailAddress == event.emailAddress).selected =
    //     false;
    //   this.items.find((x) => x.emailAddress == event.emailAddress).isSelected =
    //     false;
    //   noOfInvitiesSelected = this.items.filter(
    //     (i) => i.selected == true
    //   )?.length;
    //   this.appStateSrv.showToast('Maximum limit of invitees reached.');
    //   return;
    // } else {
    //   this.items.find((x) => x.emailAddress == event.emailAddress).selected =
    //     true;
    // }
    // this.totalSelected = noOfInvitiesSelected;
    this.totalSelected = this.items.filter(el => el.selected == true).length;
    if (this.totalSelected >= this.noOfPax - 1) {
      if (!item.selected)
        this.appStateSrv.showToast('Maximum limit of invitees reached.');
      this.items = this.items.map(el => {
        if (item.emailAddress == el.emailAddress) {
          el.selected = false;
          el.isSelected = false;
        }
        return el;
      });

    } else {
      this.items = this.items.map(el => {
        if (item.emailAddress == el.emailAddress) {
          el.selected = true;
          el.isSelected = true;
        }
        return el;
      });
    }
    this.totalSelected = this.items.filter(el => el.selected == true).length;
  }

  public onClickAdd(e) {
    e.preventDefault();
    const formStatus = this.formValidator();
    if (!formStatus.valid) {
      console.log('Error', formStatus);
      this.fieldErrors = formStatus.errFields;
      console.log('fieldErrors', this.fieldErrors);
      window.scrollTo(0, 0);
      return;
    }
    this.entity.meetingRoomBookingId = this.MeetingId;
    this.apiService
      .post(APIs.saveExternalMeetingInvitees, this.entity, '')
      .subscribe(
        (result) => {
          this.getPageData2();
          this.appStateSrv.showToast('New Member added succesfully.');
          // this.modalService.dismissAll();
          this.showExternalDetails = false;
          // this.modalService.open(this.inviteeModalContent, { size: 'xl' });
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  public onClickSendInvite() {
    this.entityList = new EntityList();
    let InviteesList: any[]=[] ;

    this.fieldErrors = [];

    // if (
    //   this.items.filter((i) => i.selected == true)?.length >=
    //   this.noOfPax - 1
    // ) {
    //   return this.appStateSrv.showToast('Maximum limit of invitees reached.');
    // }

    this.items
      .filter((i) => i.selected == true)
      .forEach((d) => {
        var meetingAttendeesPresent = this.meetingAttendees.find(
          (a) => a.id == d.id
        );
        // if (meetingAttendeesPresent == null) {
          InviteesList.push({
            UserId: d.userId,
            FirstName: d.fullName,
            LastName: d.LastName,
            phoneNumber: d.phoneNumber,
            meetingRoomBookingId: this.MeetingId,
            emailAddress: d.emailAddress,
            externalUserId: d.externalUserId,
            Id: d.id,
          });
          // this.apiService.post(APIs.saveMeetingInvitees2, this.entityList, '').subscribe(
          //   result => { },
          //   error => { console.log('error', error) }
          // );
          // InviteesList.push(this.entityList);
        // }
      });
    const body = {
      MeetingInviteeViewModelList: InviteesList,
    };
    this.apiService.post(APIs.saveMeetingInvitees, body, '').subscribe(
      (result) => {
        this.getPageData2();
      },
      (error) => {
        console.log('error', error);
      }
    );
    this.modalService.dismissAll();
  }

  public RemoveMemberFromMeeting(attendees) {
    this.apiService
      .post(APIs.removeMemberFromMeeting + `/${attendees.id}`, '', '')
      .subscribe(
        (result) => {
          this.getPageData2();
        },
        (error) => {
          console.log('error', error);
        }
      );
  }

  keyPressAlphaNumbersDecimal(event) {
    var inp = String.fromCharCode(event.keyCode);
    var charCode = event.which ? event.which : event.keyCode;
    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      if (charCode != 32) {
        event.preventDefault();
        return false;
      }
    }
  }

  keyPressNumbersDecimal(event) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  formValidator(type: string = 'add'): { valid: boolean; errFields: any } {
    const validate = (firstName, lastName, emailId, phoneNumber) => {
      let errFields = [];
      if (type == 'firstName' || type == 'add')
        if (firstName == undefined) errFields.push('fnameEmpty');
        else if (!firstName || !/^[a-zA-Z ]{2,30}$/.test(firstName)) {
          if (firstName.length > 30) {
            const i = errFields.indexOf('fnamelen');
            if (i > -1) errFields.splice(i, 1);
            errFields.push('fnamelen');
          } else {
            const i = errFields.indexOf('fnamelen');
            if (i > -1) errFields.splice(i, 1);
          }
          const i = errFields.indexOf('fname');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('fname');
        } else {
          const i = errFields.indexOf('fname');
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'lastName' || type == 'add')
        if (lastName == undefined) errFields.push('lnameEmpty');
        else if (!lastName || !/^[a-zA-Z ]{1,30}$/.test(lastName)) {
          if (lastName.length > 30) {
            const i = errFields.indexOf('lnamelen');
            if (i > -1) errFields.splice(i, 1);
            errFields.push('lnamelen');
          } else {
            const i = errFields.indexOf('lnamelen');
            if (i > -1) errFields.splice(i, 1);
          }
          const i = errFields.indexOf('lname');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('lname');
        } else {
          const i = errFields.indexOf('lname');
          if (i > -1) errFields.splice(i, 1);
        }
      if (emailId == undefined) errFields.push('emailEmpty');
      else if (type == 'email' || type == 'add')
        if (
          !emailId ||
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(emailId)
        ) {
          const i = errFields.indexOf('email');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('email');
        } else {
          const i = errFields.indexOf('email');
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'phone' || type == 'add')
        if (phoneNumber && !/^\d{10}$/.test(phoneNumber)) {
          const i = errFields.indexOf('phone');
          if (i > -1) errFields.splice(i, 1);
          errFields.push('phone');
        } else {
          const i = errFields.indexOf('phone');
          if (i > -1) errFields.splice(i, 1);
        }

      if (errFields.length > 0) return { valid: false, errFields: errFields };
      else return { valid: true, errFields: [] };
    };

    return validate(
      this.entity.firstName,
      this.entity.lastName,
      this.entity.emailAddress,
      this.entity.phoneNumber
    );
  }

  inputModelChange(type: string) {
    const formStatus = this.formValidator(type);
    this.fieldErrors = [];
    if (!formStatus.valid) this.fieldErrors = formStatus.errFields;
    //console.log('fields errors', this.fieldErrors);
  }
  enterName(field) {
    if (field == 'firstName') {
      this.fname = !this.fname;
    }
    if (field == 'lastName') {
      this.lname = !this.lname;
    } else if (field == 'email') {
      this.email = !this.email;
    } else if (field == 'mobile') {
      this.mobile = !this.mobile;
    }
  }

  convertDateFormat(date) {
    if (date !== null)
      return this.dateSrv.convertDateToLocaleString(
        Number(date.split('-')[2]),
        Number(date.split('-')[1] - 1),
        Number(date.split('-')[0])
      );
  }
}

class Entity {
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  meetingRoomBookingId: number;
}

class MeetingInfo {
  fromTime: string;
  toTime: string;
  date: string;
  duration: number;
}

class EntityList {
  UserId: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  externalUserId: number;
  meetingRoomBookingId: number;
}
